import env from '.env'

import shoprite from './login_details.shoprite'
import tdb from './login_details.tdb'

const components = { shoprite, tdb }

export default components[env.retail.theme] || shoprite
